import {ElMessage} from "element-plus";
import i18n from "@/i18n";
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export class ClipboardHelper {
  // 使用 navigator.clipboard
  static async copyText(text) {
    if (text == null) {
      return null;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
            setTimeout(() => {
                ElMessage.success(i18n.global.t('console.copy_the_results_success'));
            }, 500); // 显示复制成功信息2秒
        }).catch(err => {
            console.error('复制失败:', err);
            ElMessage.error(i18n.global.t('console.copy_the_results_failed'))
        });
    } else {
        this.fallbackCopyText(text);
    }
  }
  // 备用方法
  static fallbackCopyText(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';

    document.body.appendChild(textArea);
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (!successful) {
        ElMessage.error(i18n.global.t('console.copy_the_results_failed'))
      } else {
        ElMessage.success(i18n.global.t('console.copy_the_results_success'));
      }
    } catch (err) {
      console.error('复制失败:', err);
      ElMessage.error(i18n.global.t('console.copy_the_results_failed'))
    } finally {
      document.body.removeChild(textArea);
    }
  }
}


async function loadFingerprintJS() {
  try {
      return await FingerprintJS.load();
  } catch (err) {
      console.error('FingerprintJS加载失败:', err);
      throw err;
  }
}

export async function InitFingerprint() {
  try {
    // 检查是否已有visitorId
    const storedVisitorId = localStorage.getItem('visitorId');
    if (storedVisitorId) {
      return storedVisitorId;
    }

    // 动态加载FingerprintJS
    const fp = await loadFingerprintJS();
    const result = await fp.get();

    // 存储visitorId
    let visitorId = result.visitorId;
    localStorage.setItem('visitorId', visitorId);

    console.log('[LogTracker] generated visitorId:', visitorId);
    return visitorId
  } catch (error) {
    console.error('[LogTracker] fingerprint generation failed:', error);
    // 生成随机visitorId作为fallback
    let visitorId = `fallback_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('visitorId', visitorId);
    return visitorId
  }
}

export async function getInviteCode() {
  try {
    const params = new URLSearchParams(window.location.search);
    const value = params.get('invite');
    return value ? decodeURIComponent(value) : null;
  } catch (e) {
    console.error('解析invite参数出错:', e);
    return null;
  }
}
